import { createFileRoute } from '@tanstack/react-router';

import { OperationDangerZone } from '../../features/operations/operation-danger-zone';
import { OperationDetailShell } from '../../features/operations/operation-detail-shell';
import { OperationForm } from '../../features/operations/operation-form';
import { operationBreadcrumbBadges } from '../../features/operations/operation-route-chrome';
import { operationDetailQueryOptions } from '../../features/operations/queries';

export const Route = createFileRoute('/operations/$operation_id')({
  staticData: {
    // Resolve the operation name from the cache so the breadcrumb reads
    // "Operations > {name}" instead of "Operations > Operation". Returns
    // null until the detail query has populated, which the breadcrumbs
    // component treats as "render no leaf yet".
    breadcrumb: (match, queryClient) => {
      const { operation_id: operationId } = match.params as { operation_id: string };
      const data = queryClient.getQueryData(operationDetailQueryOptions(operationId).queryKey);
      return data?.operation_name ?? null;
    },
    // ENG-624: the version + Archived badges; ENG-813: the Draft/Staged/Live
    // lifecycle badge. Shared across all four operation-detail tabs.
    breadcrumbBadges: operationBreadcrumbBadges,
    layout: 'full-height',
  },
  component: OperationDetailsPage,
});

function OperationDetailsPage() {
  const { operation_id: operationId } = Route.useParams();

  return (
    <OperationDetailShell operationId={operationId} active="details">
      {(operation, partnerId) => (
        // min-h-full + mt-auto keeps the Danger Zone flushed to the bottom of
        // the page regardless of how short the form is.
        <div className="flex min-h-full flex-col gap-6 p-6">
          <OperationForm operation={operation} />
          <div className="mt-auto pt-6">
            <OperationDangerZone operation={operation} partnerId={partnerId} />
          </div>
        </div>
      )}
    </OperationDetailShell>
  );
}
